import { render } from 'react-dom';
import App from './App';
import { createWebComponents } from './web-components';
import './i18n/config';
import i18n from 'i18next';
import { ConfigProvider } from 'antd';
import { getLocale } from './utils/locale';
import { isLocal } from './constants';
import 'moment/locale/es';
import 'moment/locale/pt-br';
import moment from 'moment';

const useWebComponents = JSON.parse(process.env.REACT_APP_USE_WEBCOMPONENTS as string);

if (isLocal) {
  const { worker } = require('./mocks/browser');
  worker.start();
}

moment.locale(i18n.language);

if (!useWebComponents) {
  render(
    <ConfigProvider locale={getLocale(i18n.language)}>
      <App />
    </ConfigProvider>,
    document.getElementById('root')
  );
}

createWebComponents();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
